// import React from "react";
// import Navbar from "../../Components/Layout/Navbar";
// import Footer from "../../Components/Layout/Footer";
// import TopFooter from "../../Components/Layout/Footer/TopFooter";

// const NonAuthLayout = (props) => {
//   return (
//     <React.Fragment>
//       <Navbar />
//       {props.children}
//       <TopFooter />
//       <Footer />
//     </React.Fragment>
//   );
// };

// export default NonAuthLayout;

import React from "react";
import Navbar from "../../Components/Layout/Navbar";
import Footer from "../../Components/Layout/Footer";
import TopFooter from "../../Components/Layout/Footer/TopFooter";
import { FaWhatsapp, FaMapMarkerAlt } from "react-icons/fa";
import { Link } from "react-router-dom";

const NonAuthLayout = (props) => {
  return (
    <React.Fragment>
      <Navbar />
      {props.children}
      <TopFooter />
      <Footer />

      <div className="fixed bottom-16 sm:bottom-10 right-5 flex flex-col gap-3 z-50">
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://wa.me/+919650988084"
          className="bg-green-500 hover:bg-green-600 text-white p-3 rounded-full shadow-lg transition-all duration-300"
        >
          <FaWhatsapp size={30} />
        </a>
        <Link
          to="/display-house"
          className="bg-red-500 hover:bg-red-600 text-white p-3 rounded-full shadow-lg transition-all duration-300 flex justify-center items-center"
        >
          <FaMapMarkerAlt size={26} />
        </Link>
      </div>
    </React.Fragment>
  );
};

export default NonAuthLayout;
